export default __webpack_public_path__ + "static/media/UniLogo.6ce4e4d6.svg";